import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import useTheme from '@common/hooks/useTheme'

const SeedPhraseIcon: React.FC<SvgProps> = ({ width = 43, height = 50, color, ...rest }) => {
  const { theme } = useTheme()
  return (
    <Svg width={width} height={height} viewBox="0 0 43.285 50.116" {...rest}>
      <G>
        <Path
          fill="none"
          stroke={color || theme.iconPrimary}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M17.99 1.675 6.017 6.187A8.329 8.329 0 0 0 1 13.412v17.834a11.669 11.669 0 0 0 4.153 8.257l10.321 7.705a10.925 10.925 0 0 0 12.337 0l10.321-7.705a11.669 11.669 0 0 0 4.153-8.257V13.412a8.334 8.334 0 0 0-5.017-7.249L25.29 1.675a12.205 12.205 0 0 0-7.3 0Z"
        />
        <Path
          fill={color || theme.iconPrimary}
          d="M13.56 25.284a.6.6 0 0 1-.54 1.072l-1.569-.664a.6.6 0 0 0-.833.5l-.177 2.263a.6.6 0 0 1-1.2 0l-.174-2.263a.6.6 0 0 0-.834-.506l-1.573.67a.6.6 0 0 1-.537-1.072l1.145-.662a.6.6 0 0 0 0-1.039l-1.14-.662a.6.6 0 0 1 .532-1.072l1.568.666a.6.6 0 0 0 .834-.506l.181-2.263a.6.6 0 0 1 1.2 0l.177 2.263a.6.6 0 0 0 .834.506l1.566-.666a.6.6 0 0 1 .54 1.072l-1.139.663a.6.6 0 0 0 0 1.039Z"
        />
        <Path
          fill={color || theme.iconPrimary}
          d="M25.361 25.284a.6.6 0 0 1-.54 1.072l-1.569-.664a.6.6 0 0 0-.833.5l-.177 2.263a.6.6 0 0 1-1.2 0l-.174-2.263a.6.6 0 0 0-.834-.506l-1.573.67a.6.6 0 0 1-.537-1.072l1.145-.662a.6.6 0 0 0 0-1.039l-1.14-.662a.6.6 0 0 1 .532-1.072l1.568.666a.6.6 0 0 0 .834-.506l.181-2.263a.6.6 0 0 1 1.2 0l.177 2.263a.6.6 0 0 0 .834.506l1.566-.666a.6.6 0 0 1 .54 1.072l-1.139.663a.6.6 0 0 0 0 1.039Z"
        />
        <Path
          fill={color || theme.iconPrimary}
          d="M37.162 25.284a.6.6 0 0 1-.54 1.072l-1.569-.664a.6.6 0 0 0-.833.5l-.177 2.263a.6.6 0 0 1-1.2 0l-.174-2.263a.6.6 0 0 0-.834-.506l-1.573.67a.6.6 0 0 1-.537-1.072l1.145-.662a.6.6 0 0 0 0-1.039l-1.14-.662a.6.6 0 0 1 .532-1.072l1.568.666a.6.6 0 0 0 .834-.506l.181-2.263a.6.6 0 0 1 1.2 0l.177 2.263a.6.6 0 0 0 .834.506l1.566-.666a.6.6 0 0 1 .54 1.072l-1.139.663a.6.6 0 0 0 0 1.039Z"
        />
      </G>
    </Svg>
  )
}

export default React.memo(SeedPhraseIcon)
